import { render, staticRenderFns } from "./RelevanceDistribution.vue?vue&type=template&id=befe88b0&scoped=true&"
import script from "./RelevanceDistribution.vue?vue&type=script&lang=js&"
export * from "./RelevanceDistribution.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceDistribution.vue?vue&type=style&index=0&id=befe88b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe88b0",
  null
  
)

export default component.exports